import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ShopService } from '@app/services/shops/shop.service';
import { UserService } from '@app/services/user/user.service';
import { catchError, filter, first, map, of, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaxxGuard {
  constructor(
    private shopService: ShopService,
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate() {
    return this.shopService.shop$.pipe(
      filter((shop) => !!shop),
      first(),
      timeout(5000),
      map((shop) => {
        const isWrite = this.userService.isWrite();
        // const hasMaxxEnabled = shop.metadata?.[MAXX_METADATA_KEY];
        return isWrite ? true : this.router.parseUrl('');
      }),
      catchError((error) => {
        // TODO: Add consistent error handling and reporting across all guards (custom-dashboard-guard, full-platform.guard, etc.)
        console.error('Maxx guard error:', error);
        return of(this.router.parseUrl(''));
      }),
    );
  }
}
